import { createSelector } from 'reselect';

export const getSnowflake = (state) => state.snowflake;

export const isSnowflakeLoading = createSelector(
  getSnowflake,
  ({ loading }) => loading
);

export const isSnowflakeDownloading = createSelector(
  getSnowflake,
  ({ downloading }) => downloading
);

export const getSnowflakeStats = createSelector(
  getSnowflake,
  ({ stats }) => stats
);

export const getSnowflakeError = createSelector(
  getSnowflake,
  ({ error }) => error
);

export const getSnowflakeFirstTimers = createSelector(
  getSnowflake,
  ({ firstTimers }) => firstTimers
);

// The location/date range the loaded rows were actually fetched with — not the
// current picker selection, which can move on without triggering a refetch.
export const getSnowflakeFirstTimersFilters = createSelector(
  getSnowflake,
  ({ firstTimersFilters }) => firstTimersFilters
);

export const isSnowflakeLoadingFirstTimers = createSelector(
  getSnowflake,
  ({ loadingFirstTimers }) => loadingFirstTimers
);

export const getSnowflakeFirstTimersError = createSelector(
  getSnowflake,
  ({ errorFirstTimers }) => errorFirstTimers
);

export const getSnowflakeTerminatedMembers = createSelector(
  getSnowflake,
  ({ terminatedMembers }) => terminatedMembers
);

export const getSnowflakeTerminatedMembersFilters = createSelector(
  getSnowflake,
  ({ terminatedMembersFilters }) => terminatedMembersFilters
);

export const isSnowflakeLoadingTerminatedMembers = createSelector(
  getSnowflake,
  ({ loadingTerminatedMembers }) => loadingTerminatedMembers
);

export const getSnowflakeTerminatedMembersError = createSelector(
  getSnowflake,
  ({ errorTerminatedMembers }) => errorTerminatedMembers
);

export const getSnowflakeDateRange = createSelector(
  getSnowflake,
  ({ dateRange }) => dateRange
);

export const getSnowflakeLocations = createSelector(
  getSnowflake,
  ({ locations }) => locations
);

export const isSnowflakeLoadingLocations = createSelector(
  getSnowflake,
  ({ locationsLoading }) => locationsLoading
);

export const getSnowflakeLocationsError = createSelector(
  getSnowflake,
  ({ locationsError }) => locationsError
);

export const getSnowflakeSelectedLocation = createSelector(
  getSnowflake,
  ({ selectedLocationId }) => selectedLocationId
);

export const getSnowflakeSelectedLocationName = createSelector(
  getSnowflakeLocations,
  getSnowflakeSelectedLocation,
  (locations, selectedLocationId) =>
    locations.find(({ id }) => id === selectedLocationId)?.name || ''
);
